import styled from "styled-components";
import StyledSection from "../Common/Section.styled";
import Background from "../../images/AboutImageBackground_Artboard-NoBrush_1920x1080.svg"

const StyledAbout = styled(StyledSection)` 
  background-image: url(${Background});
  background-position: 0 0;
  background-size: auto;
  background-repeat: no-repeat;
  background-attachment: fixed;
`

export default StyledAbout;
